/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// export * from './career-enquiries-details.dto';
export * from './career-enquiries.mapper';
export * from './career-enquiries-rest.service';
